import angular from 'angular';

export default function RecommendationController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  attachRecommendationDialog,
  confirmDialog,
  docDataService,
  serviceIds,
  editRecommendationCommentDialog,
  editRecommendationDialog,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.AM;

  vm.canExpand = vm.status !== 'No Recommendation Added';
  vm.isExpanded = false;

  // Attach Event Handlers
  vm.handleExpandRecommendation = _handleExpandRecommendation;
  vm.handleEditRecommendation = _handleEditRecommendation;
  vm.handleDeleteRecommendation = _handleDeleteRecommendation;
  vm.handleAddRecommendationNote = _handleAddRecommendationNote;
  vm.handleMarkStatusComplete = _handleMarkStatusComplete;
  vm.handleAttachItems = _handleAttachItems;
  vm.documentAttached = _documentAttached;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;
  vm.handleConfirmComplete = _handleConfirmComplete;
  vm.handleCancelComplete = _handleCancelComplete;

  _activate();

  // //////// METHODS //////////

  _initEventListeners();

  function _activate() {
    _setStatuses();
    const dfdActivate = $q.defer();

    _refreshBusinessRisks().then(
      _refreshTechnicalRisks().then(
        _refreshPriorities().then(
          _refreshRecommendationStatuses().then(
            _refreshUsers().then(dfdActivate.resolve)
          )
        )
      )
    );
  }

  function _initEventListeners() {
    $scope.$on('refreshAMBusinessRisks', _refreshBusinessRisks);
    $scope.$on('refreshAMTechnicalRisks', _refreshTechnicalRisks);
    $scope.$on('refreshAMPriorities', _refreshPriorities);
    $scope.$on('refreshAMUsers', _refreshUsers);

    $scope.$on('refreshAMRecommendation', (event, opt) => {
      if (opt.recommendationId === vm.recommendation.recommendationId) {
        _refreshRecommendation();
      }
    });

    $scope.$on('refreshAMRecommendationComments', (event, opt) => {
      if (opt.recommendationId === vm.recommendation.recommendationId) {
        _refreshRecommendationComments();
      }
    });

    $scope.$on('refreshAMRecommendationFolders', (event, opt) => {
      if (opt.recommendationId === vm.recommendation.recommendationId) {
        _refreshRecommendationFolders();
      }
    });

    $scope.$on('refreshAMRecommendationDocuments', (event, opt) => {
      if (opt.recommendationId === vm.recommendation.recommendationId) {
        _refreshRecommendationDocuments();
      }
    });

    $scope.$on('refreshAMRecommendationReports', (event, opt) => {
      if (opt.recommendationId === vm.recommendation.recommendationId) {
        _refreshRecommendationReports();
      }
    });

    $scope.$on('refreshFolderAttachments', () => {
      _refreshRecommendationFolders();
      _refreshRecommendationDocuments();
      _refreshRecommendationReports();
    });

    $scope.$on('refreshDocAttachments', (event, opt) => {
      let docisAttached = false;
      angular.forEach(vm.recommendation.recommendationDocuments, (recommendationDocument) => {
        if (recommendationDocument.documentId === opt.document.documentId) {
          docisAttached = true;
        }
      });

      if (docisAttached) {
        _refreshRecommendationDocuments();
      }
    });
  }

  function _setStatuses() {
    vm.recommendation.canAddItemNote = (vm.recommendation.canAddNote || vm.recommendation.isAssignedToMe) && vm.auditIsActive;
    vm.recommendation.canAttachItemItems = (vm.recommendation.canAttachItems || vm.recommendation.isAssignedToMe) && vm.auditIsActive;

    vm.recommendation.canChangeItemStatus = (vm.recommendation.canChangeStatus || vm.recommendation.isAssignedToMe || vm.recommendation.canEdit)
      && vm.recommendation.statusId !== 3 && vm.auditIsActive;

    vm.recommendation.canEditItem = vm.recommendation.canEdit && vm.auditIsActive;
    vm.recommendation.canDeleteItem = vm.recommendation.canDelete && vm.auditIsActive;
  }

  function _handleExpandRecommendation() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      _refreshRecommendation();
    }
  }

  function _refreshRecommendation() {
    const dfdRefresh = $q.defer();

    amDataService.getRecommendation(vm.recommendation.recommendationId).then((response) => {
      vm.recommendation = response.data;
      _setStatuses();
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshRecommendationComments() {
    const dfdRefresh = $q.defer();

    amDataService.getRecommendationCommentsByRecommendation(vm.recommendation.recommendationId).then((response) => {
      vm.recommendation.recommendationComments = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshRecommendationFolders() {
    const dfdRefresh = $q.defer();

    amDataService.getRecommendationFoldersByRecommendation(vm.recommendation.recommendationId).then((response) => {
      vm.recommendation.recommendationFolders = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshRecommendationDocuments() {
    const dfdRefresh = $q.defer();

    amDataService.getRecommendationDocumentsByRecommendation(vm.recommendation.recommendationId).then((response) => {
      vm.recommendation.recommendationDocuments = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshRecommendationReports() {
    const dfdRefresh = $q.defer();

    amDataService.getRecommendationReportsByRecommendation(vm.recommendation.recommendationId).then((response) => {
      vm.recommendation.recommendationReports = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshBusinessRisks() {
    return amSharedModelService.getBusinessRisks().then((businessRisks) => {
      vm.businessRisks = businessRisks;
    });
  }

  function _refreshTechnicalRisks() {
    const dfdRefresh = $q.defer();

    vm.technicalRisks = amSharedModelService.technicalRisks;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _refreshPriorities() {
    const dfdRefresh = $q.defer();

    vm.priorities = amSharedModelService.priorities;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _refreshRecommendationStatuses() {
    const dfdRefresh = $q.defer();

    vm.statuses = amSharedModelService.recommendationStatuses;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _refreshUsers() {
    const dfdRefresh = $q.defer();

    vm.users = amSharedModelService.applicationUsers;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _handleEditRecommendation($event) {
    loaderService.showViewLoader = true;
    _refreshRecommendation().then(() => {
      ssDialogService.dialogs.auditTrail.editRecommendationDialog = ssDialogService.alert(
        editRecommendationDialog.getOptions($event, {
          customerId: vm.customerId,
          auditId: vm.auditId,
          auditIsActive: vm.auditIsActive,
          businessRisks: vm.businessRisks,
          technicalRisks: vm.technicalRisks,
          priorities: vm.priorities,
          statuses: vm.statuses,
          users: vm.users,
          recommendation: vm.recommendation,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.auditTrail.editRecommendationDialog);
      loaderService.showViewLoader = false;
    });
  }

  function _handleAddRecommendationNote($event) {
    ssDialogService.dialogs.auditTrail.editRecommendationCommentDialog = ssDialogService.alert(
      editRecommendationCommentDialog.getOptions($event, {
        recommendationId: vm.recommendation.recommendationId,
        recommendationCommentId: -1,
        recommendationCommentText: '',
      })
    );
    ssDialogService.show(ssDialogService.dialogs.auditTrail.editRecommendationCommentDialog);
  }

  function _handleAttachItems($event) {
    loaderService.showViewLoader = true;
    docDataService.getFolderProperties(-1).then((getFolderResponse) => {
      vm.rootFolder = getFolderResponse.data;

      ssDialogService.dialogs.auditTrail.attachRecommendationDialog = ssDialogService.alert(
        attachRecommendationDialog.getOptions($event, {
          serviceId: vm.serviceId,
          recommendationId: vm.recommendation.recommendationId,
          folder: vm.rootFolder,
          attachCallback: vm.documentAttached,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.auditTrail.attachRecommendationDialog);
    });
  }

  function _documentAttached() {
    $rootScope.$broadcast('refreshAMRecommendation', { recommendationId: vm.recommendation.recommendationId });
  }

  // /////////////// Delete /////////////////

  function _handleDeleteRecommendation($event) {
    ssDialogService.dialogs.auditTrail.deleteRecommendationConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Recommendation?',
        message: `Are you sure you want to delete Recommendation "${vm.recommendation.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteRecommendationConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amSharedModelService.deleteRecommendation(vm.recommendation)
      .then(() => {
        // deleteCallback is wrapped in a function by Angular
        vm.deleteCallback()(vm.recommendation);
        alerts.success('The Recommendation has been deleted successfully.');
        $rootScope.$broadcast('refreshNotifications');
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting the Recommendation.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteRecommendationConfirmDialog);
  }

  // /////////////// Complete /////////////////

  function _handleMarkStatusComplete($event) {
    ssDialogService.dialogs.auditTrail.completeRecommendationConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Complete Recommendation?',
        message: `Are you sure you want to mark Recommendation "${vm.recommendation.name}" as completed?`,
        handleYesClick: _handleConfirmComplete,
        handleNoClick: _handleCancelComplete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.completeRecommendationConfirmDialog);
  }

  function _handleConfirmComplete() {
    loaderService.showViewLoader = true;
    amDataService.setRecommendationStatus(vm.recommendation.recommendationId, 3).then((response) => {
      if (response.status !== 201) {
        alerts.error('Error occurred while marking the Recommendation complete.');
      } else {
        loaderService.showViewLoader = false;
        alerts.success('The Recommendation has successfully been marked as complete.');
        $rootScope.$broadcast('refreshAMRecommendation', { recommendationId: vm.recommendation.recommendationId });
        $rootScope.$broadcast('refreshNotifications');
        _closeCompleteDialog();
      }
    });
  }

  function _handleCancelComplete() {
    _closeCompleteDialog();
  }

  function _closeCompleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.completeRecommendationConfirmDialog);
  }
}

RecommendationController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'attachRecommendationDialog',
  'confirmDialog',
  'docDataService',
  'serviceIds',
  'editRecommendationCommentDialog',
  'editRecommendationDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
